/** Checking geometric uniqueness of zones. */

import { size } from 'lodash';

// 3rd-party wrapped
import { equal } from '3rd-party-wrappers/turf';

// util
import { getGeometry } from 'geometry/geojson/convert';

/** Check if two zones are geometrically equivalent. */
export const doZonesHaveUniqueGeometry = (zone1, zone2) =>
  !equal(getGeometry(zone1.geoJson), getGeometry(zone2.geoJson));

/** Check if two sets of zones are geometrically equivalent. */
export const doZoneSetsHaveUniqueGeometry = (zones1, zones2) => {
  if (size(zones1) !== size(zones2)) {
    return true;
  }
  return Object.keys(zones1).some( (zoneId) => {
    const zone2 = zones2[zoneId];
    return (zone2 === undefined) ? true : doZonesHaveUniqueGeometry(zones1[zoneId], zone2);
  });
};
